// Misc
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

// Atoms
import Container from 'atoms/Container';

// Components
import FooterMenu from './Menu';

// Styles
import styles from './styles';

@withStyles(styles)
export default class Footer extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    containerClassName: PropTypes.any
  };

  static defaultProps = {
    wrapChildren: children => children
  };

  render() {
    const { classes, containerClassName } = this.props;
    return (
      <div className={classes.root}>
        <Container className={containerClassName}>
          <FooterMenu />
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js